"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const newBoxStyles_1 = __importDefault(require("./newBoxStyles"));
const theme_1 = __importDefault(require("../../styles/theme"));
const touchableElement_1 = __importDefault(require("../pressables/touchableElement"));
const text_1 = __importStar(require("../text/text"));
const icon_1 = __importStar(require("../icon/icon"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const textStyles_1 = __importDefault(require("../text/textStyles"));
const NewBox = ({ title, textArea, action, srcImg, btn, butonText, eventName, display, }) => {
    let button = null;
    let image = null;
    if (srcImg) {
        image = react_1.default.createElement(react_native_1.Image, { source: srcImg, style: newBoxStyles_1.default.imageSize });
    }
    if (btn) {
        button = (react_1.default.createElement(touchableElement_1.default, { onPress: action, eventName: eventName || '', style: [newBoxStyles_1.default.content, newBoxStyles_1.default.boxButton] },
            react_1.default.createElement(react_native_1.View, { style: newBoxStyles_1.default.boxButton },
                react_1.default.createElement(text_1.default, { color: colors_1.default.COLOR_WHITE, titleType: text_1.TEXT_TYPE_SUBTITLE }, butonText))));
    }
    return (react_1.default.createElement(react_native_1.View, { style: [newBoxStyles_1.default.boxContainer, display ? null : styles_1.default.noDisplay] },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexTwo] },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(react_native_1.View, { style: newBoxStyles_1.default.textContent },
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, biggerSubtitle: true, style: textStyles_1.default.bold }, title),
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, biggerSubtitle: true, color: theme_1.default.colors.COLOR_GRAY_DARK }, textArea)),
                    react_1.default.createElement(react_native_1.View, { style: [newBoxStyles_1.default.content] }, image),
                    button)),
            !image && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.justifyFlexEnd] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionColumn, { alignSelf: 'flex-end' }] },
                    react_1.default.createElement(icon_1.default, { name: icon_1.GET_LOAN_ICON })))))));
};
NewBox.defaultProps = {
    butonText: undefined,
    srcImg: undefined,
    eventName: undefined,
};
exports.default = NewBox;
